import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './faq.css';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const faqData = [
  {
    title: 'General Questions',
    items: [
      {
        question: 'What is StepBerlin?',
        answer:
          'StepBerlin is a relocation assistance service that helps students and professionals settle in Germany. We offer services such as airport pickup, accommodation support, city registration, bank account setup, and university admissions assistance.',
      },
      {
        question: 'Who can use StepBerlin’s services?',
        answer:
          'Our services are for students, job seekers, and professionals moving to Germany. Whether you’re coming for studies, work, or personal reasons, we provide support to make your transition smooth.',
      },
      {
        question: 'How long has StepBerlin been operating?',
        answer: 'We have been helping students and professionals relocate to Germany for the past 3–5 years.',
      },
    ],
  },
  {
    title: 'University Admission',
    items: [
      {
        question: 'Can I study in Germany for free?',
        answer:
          'Yes! Public universities in Germany offer tuition-free education for students, except for a small semester fee. StepBerlin, in collaboration with First Stone, assists students in securing admission to public universities.',
      },
      {
        question: 'Do private universities in Germany charge tuition fees?',
        answer:
          'Yes, private universities charge tuition fees, but they offer more flexible admission requirements and English-taught courses. StepBerlin assists with both public and private university admissions.',
      },
    ],
  },
  {
    title: 'Relocation & Settlement',
    items: [
      {
        question: 'Does StepBerlin provide accommodation?',
        answer:
          'We do not provide accommodation directly, but we assist students in finding and securing a room based on their budget and preferences.',
      },
      {
        question: 'What is included in the airport pickup service?',
        answer:
          'Our airport pickup service includes a guide to take you from the airport to your accommodation using public transport. If you choose our Premium Package, we also assist with check-in and essentials.',
      },
      {
        question: 'Do you help with city registration and bank accounts?',
        answer:
          'Yes! Our Standard and Premium Packages include full support for city registration, tax ID, and bank account setup.',
      },
    ],
  },
  {
    title: 'Work & Jobs in Germany',
    items: [
      {
        question: 'Can you help students find part-time jobs?',
        answer:
          'While we don’t provide job placements, we offer CV creation (Europass format), LinkedIn optimization, and guidance on job portals where students can find part-time jobs.',
      },
      {
        question: 'Is LinkedIn Premium worth it for students?',
        answer:
          'Yes! LinkedIn Premium helps students network with recruiters and find internships or part-time jobs. Our Premium Package includes LinkedIn Premium setup.',
      },
    ],
  },
  {
    title: 'Payment & Refunds',
    items: [
      {
        question: 'How much do StepBerlin’s services cost?',
        answer:
          'We offer three packages: Basic, Standard, and Premium. Prices depend on the services included. Contact us for details!',
      },
      {
        question: 'What is your refund policy?',
        answer:
          'Refunds are only provided if StepBerlin fails to deliver a promised service. No refunds are given for services already rendered or for changes in personal circumstances.',
      },
    ],
  },
];

const AccordionItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);

  return (
    <motion.div
      className="accordion-item"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ scale: 1.02 }}
      transition={{ duration: 0.3 }}
    >
      <div className="question" onClick={() => setOpen(!open)}>
        <h4>{question}</h4>
        <span className="icon">{open ? <FaChevronUp /> : <FaChevronDown />}</span>
      </div>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            className="answer"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <p>{answer}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default function FAQPage() {
  return (
    <div className="faq-page">
      <div className="faq-hero">
        <h1>Frequently Asked Questions</h1>
        <p>We’ve answered the most common questions about relocating to Germany. Still curious? Contact us!</p>
      </div>

      <div className="faq-container">
        {faqData.map((section, index) => (
          <div key={index} className="faq-section">
            <h2>{section.title}</h2>
            {section.items.map((item, i) => (
              <AccordionItem key={i} question={item.question} answer={item.answer} />
            ))}
          </div>
        ))}
      </div>

      <div className="faq-contact">
        <h3>Still have questions?</h3>
        <p>Email: <a href="mailto:care@firststones.in">care@firststones.in</a></p>
        <p>Phone: <a href="tel:+4917684830871">+49 176 84830871</a></p>
        <p>Website: <a href="https://stepberlin.com">stepberlin.com</a></p>
      </div>
    </div>
  );
}
